const initialState = {
    IA: {},
};

const SET_IA = "SET_IA";

export const setIA = (IA) => ({ type: SET_IA, IA });

export default function xapiReducer(state = initialState, action) {
    switch (action.type) {
        case SET_IA:
            return {
                ...state,
                IA: action.IA,
            };
        default:
            return state;
    }
}
